/**
 *移动至
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import BaseComponent from "../../../base/BaseComponent";
import {Col, Modal, Row,Empty,Divider } from "antd";
import {uuid} from "../../../utils";
import Position from "./Position";
import CmForm from "../../../components/CmForm/CmForm";
import {Scrollbars} from "react-custom-scrollbars";
import {message} from './Mess';
import nullData from './resourcePool/img/NullData.png'

export default class Removal extends BaseComponent {
    static defaultProps = {
        backList: []
    };
    static propTypes = {
        backList: PropTypes.array.isRequired,//返回数组
    };

    constructor(props) {

        super(props);
        this.state = {
            currentId: '',//当前点击那个就是那个
            rootId: '',//跟节点  不变
            remove: false,//控制弹框的展示
            removeList: [],//弹框里面移动至的列表
            checkArray: [],//选中 的数据
            IsTile:false,//false  代表文件库过来的  true 代表检索页面来的
            resourceName:'' //检索页面需要传是是部门 还是个人 全部 公共
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }
    modalKey = uuid();
    show(refreshKey, currentId, rootId, checkArray, IsDefault,IsTile,resourceName) {
        if (refreshKey) {
            this.modalKey = uuid();
        }
        if (IsDefault) {
            this.setState({IsDefault: IsDefault})
        }
        if (IsTile) {
            this.setState({IsTile: IsTile})
        }
        if (resourceName) {
            this.setState({resourceName: resourceName})
        }
        this.setState({ currentId: currentId, rootId: rootId, checkArray: checkArray}, () => {
            if(IsTile){
                this.getList()
            }else{
                this.getData()
            }
        });
    }

    render() {
        return (
            <Modal
                maskClosable={false}
                keyboard={true}
                title='移动至'
                centered
                key={this.modalKey}
                width={'800px'}
                okText="移动到此"
                onOk={() => {
                    this.mover()
                }}
                visible={this.state.remove}
                onCancel={() => {
                    this.setState({remove: false})
                }}
            >
                <CmForm onSubmit={() => {
                    this.mover()
                }}>
                    <div>
                        <div style={{height: '500px', margin: '0 auto'}}>
                            <Position onRef={(position) => this.setPosition = position}
                                      onSaveCallback={(id) => {
                                          this.setState({currentId: id}, () => {
                                              if(this.props.IsTile){
                                                  this.getList()
                                              }else{
                                                  this.getData()
                                              }
                                          })
                                      }}></Position>
                            <Scrollbars
                                style={{height: '480px', marginTop: '10px'}}
                            >
                                {this.state.removeList.length ?
                                    <div>{this.state.removeList && this.state.removeList.length && this.state.removeList.map((item, index) => {
                                        return (
                                            <Row key={item.id} style={{
                                                lineHeight: '50px',
                                                height: '50px',
                                                borderRadius: '8px',
                                                clear: 'both',
                                                cursor: 'pointer'
                                            }} onClick={() => {
                                                this.onDoubleClick(item)
                                            }}>
                                                <Col span={24} style={{paddingLeft: '15px'}}>
                                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                                        <img src={item.icon ? item.icon : 'images/folder.png'} style={{
                                                            width: '24px',
                                                            height: '24px',
                                                            marginTop: '5px',
                                                            objectFit: 'cover'
                                                        }}/>
                                                        <div className={'twoText'} style={{
                                                            paddingLeft: '15px',
                                                            width: '100%',
                                                            height: '50px',
                                                        }} title={item.name}>{item.name}</div>
                                                    </div>
                                                </Col>
                                                <Divider style={{margin:0}}/>
                                            </Row>
                                        )
                                    })}</div> : <Empty style={{position: "relative",
                                        top: '50%',
                                        marginTop: '-50px',color:' rgba(0, 0, 0, 0.45)'}} image={nullData}  description={''}/>}
                            </Scrollbars>
                        </div>
                    </div>
                </CmForm>
            </Modal>
        )
    }
   //点击确认
    mover() {
        let ids = [];
        this.state.checkArray.forEach((item, index) => {
            ids.push(item.id)
        });
        this.request({
            url: "/cm-sites-storage-management/zykFile/moveVirtualFiles?targetFolderId=" + this.state.currentId,
            method: "post",
            body: ids,
            contentType: "json",
            callBack: (data) => {
                if (data) {
                    message.success('移动成功')
                    this.setState({remove: false})
                    // this.props.callBack && this.props.callBack(this.props.currentId, '', [])
                    this.props.callBack&&this.props.callBack()
                }
            }
        });
    }
    //双击
    onDoubleClick(item) {
        if (item.fileTypeEnum = 'DIR') {
            this.setState({currentId: item.id}, () => {
                this.getData()
            })
        }
    }
    //检索页面走的接口
    getList() {
        let ids = [];
        this.state.checkArray.forEach((item, index) => {
            ids.push(item.id)
        });
        this.request({
                url: "/cm-sites-storage-management/search/getRootDir",
                method: "get",
                body: {
                    aliasKey: this.state.resourceName,
                    virtualFileIds: ids.join(',')
                },
                contentType: 'json',
                callBack: (data) => {
                    if (data) {
                     this.setState({currentId:data,rootId:data,remove: true},()=>{
                         this.getData(ids)
                     })
                    }
                }
            });
    }
    //文件库走的移动至
    getData(){
        let ids = [];
        this.state.checkArray.forEach((item, index) => {
            ids.push(item.id)
        });
        this.request({
            url: "/cm-sites-storage-management/zykFile/childrenDir",
            method: "post",
            body: {
                fid: this.state.currentId,
                virtualFileIds: ids.join(',')
            },
            contentType: 'json',
            callBack: (data) => {
                if (data) {
                    this.setState({removeList: data,remove: true});
                    this.setPosition.getPosition(this.state.currentId, this.state.rootId);
                }
            }
        });
    }
}